/**
 * Zoho Forms
 */
(function ($) {
  const zohoForms = {
    "home-pickup-inquire": "https://forms.everpresent.com/info558/form/HowCanWeHelpYounew1ststep/formperma/kUZxzw-LldjXObOowOXEGTzrjevZOzHGnmlaSrDJEvg?zf_rszfm=1",
    "request-home-pickup": "https://forms.everpresent.com/info558/form/EverPresentHomePickups/formperma/RqaQs9fuzTWd_YxkW1kiaYHWH1RQeLmO7hHwhTfMOzg?zf_rszfm=1",
    "get-started": "https://forms.everpresent.com/info558/form/LetsGetStartedWithYourProjectEN/formperma/japxJnNT6RW-asSdMIy5TWKd4ZWUsJWdEJ755YF0srE?zf_rszfm=1",
    "general-inquire": "https://forms.everpresent.com/info558/form/HowCanWeHelpYounew1ststep/formperma/kUZxzw-LldjXObOowOXEGTzrjevZOzHGnmlaSrDJEvg?zf_rszfm=1",
    "home-pickup": "https://forms.everpresent.com/info558/form/EverPresent/formperma/SjooNb96qJxtcwiVdivyYGGLrD0USUE2T9IatAXqO-k?zf_rszfm=1",
    "": "https://forms.everpresent.com/info558/form/InquiriesandServices/formperma/0_cZkvlA4B6M_GsMd2o0UhPT9Ut24hQNDIeZkNfKrsE?zf_rszfm=1",
  };

  const $template = $(`[data-zm-modal-template]`);
  const $body = $(`body`);
  const $iframe = $template.find(`iframe`);

  // Attribution tracking

  // Open
  $(document).on("click", `[data-zm-modal-open]`, (event) => {
    event.preventDefault();

    const id = $(event.currentTarget).data(`zm-modal-open`);
    $iframe.hide();
    $(`iframe#${id}`).show();
    $body.addClass(`zm-open`);
  });

  // Close
  const close = () => {
    $body.removeClass(`zm-open`);
    $iframe.hide();
  };
  $(document).on("click", `[data-zm-modal-close]`, close);
  $(document).on("keyup", function (e) {
    if (e.key !== "Escape") return;
    close();
  });
  $(document).on("click", `[data-zm-modal-template]`, (event) => {
    if (event.target !== event.currentTarget) return;
    close();
  });

  const buttons = {
    inquire: `<button data-zm-modal-open="general-inquire" class="everpresent-cta__button">Inquire</button>`,
    arrangeService: `<button data-zm-modal-open="arrange-service" class="everpresent-cta__button">Arrange Service</button>`,
    requestPickup: `<a href="/arrange-service/?type=home-pickup" class="everpresent-cta__button">Request a Pickup</a>`,
    getStarted: `<button data-zm-modal-open="get-started" class="everpresent-cta__button">Get Started</button>`,
  };

  $(document).on("ready", () => {
    // Clean empty paragraphs
    $(".wi-content p")
      .filter(() => {
        return $.trim($(this).text()) === "";
      })
      .remove();

    // Inquire buttons
    const $inquire = $(`a.maxbutton-inquire`);
    if ($inquire.length) {
      $inquire
        .replaceWith(buttons.inquire)
        .parents(function () {
          return this.className.match(/maxbutton-\d+-center/);
        })
        .each(function () {
          this.className = this.className.replace(/maxbutton-\d+-center/, "maxbutton-center");
        });
    }

    // Request a Pickup
    const $requestPickup = $(`a.maxbutton-request-pickup`);
    if ($requestPickup.length) {
      $requestPickup
        .replaceWith(buttons.requestPickup)
        .parents(function () {
          return this.className.match(/maxbutton-\d+-center/);
        })
        .each(function () {
          this.className = this.className.replace(/maxbutton-\d+-center/, "maxbutton-center");
        });
    }

    // Get started
    const $getStarted = $(`a.maxbutton-get-started`);
    if ($getStarted.length) {
      $getStarted
        .replaceWith(buttons.getStarted)
        .parents(function () {
          return this.className.match(/maxbutton-\d+-center/);
        })
        .each(function () {
          this.className = this.className.replace(/maxbutton-\d+-center/, "maxbutton-center");
        });
    }
  });
})(jQuery);
